<template>
  <div class="bbp-timer-modal-manual">
    <BBPTimerModalManualCounter
      :manualTimer="manualTimer"
      @update="updateManualTimer"
    />
    <div
      v-if="false"
      class="bbp-timer-modal-manual-picker"
    >
      <BBPTimePicker
        :defaultValue="startDate"
        :model.sync="startDate"
        inputWidth="78"
      />
      <div class="bbp-timer-modal-manual-picker__dash"/>
      <BBPTimePicker
        :defaultValue="endDate"
        :model.sync="endDate"
        :isLeft="true"
        inputWidth="78"
      />
    </div>
  </div>
</template>

<script>
import BBPTimerModalManualCounter
  from '@/components/Main/BBPTable/BBPTimer/BBPTimerModal/BBPTimerModalManual/BBPTimerModalManualCounter'
import BBPTimePicker from '@/components/Main/BBPTimePicker/BBPTimePicker'
import moment from 'moment'
import convertSecondsToTime from '@/mixin/convertSecondsToTime'
import convertToLocationDate from '@/mixin/convertToLocationDate'
import updateProject from '@/mixin/updateProject'
import TimerApi from '@/api/Timer/api'
import { REMINDER_STATUS } from '@/constants/recurReminders'

export default {
  name: 'BBPTimerModalManual',
  components: { BBPTimePicker, BBPTimerModalManualCounter },
  mixins: [convertSecondsToTime, convertToLocationDate, updateProject],
  props: {
    row: {
      type: Object,
      default: () => ({})
    },
    column: {
      type: Object,
      default: () => ({})
    },
    isSave: {
      type: Boolean,
      default: false
    },
    day: {
      type: Object,
      default: () => ({})
    },
    body: {
      type: Object,
      default: () => ({})
    },
    totalTime: {
      type: Number,
      default: 0
    },
    isSubproject: {
      type: Boolean,
      default: false
    },
    isHourProject: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    manualTimer: '00:00:00',
    startDate: moment().format('hh:mm A'),
    endDate: moment().format('hh:mm A'),
    lastTimeOfDay: 1650056340
  }),
  watch: {
    isSave (newVal) {
      if (newVal) this.createManualTimer()
    },
    startDate () {
      this.$emit('update:startDate', this.startDate)
    },
    endDate () {
      this.$emit('update:endDate', this.endDate)
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    },
    activeTimer: {
      get () {
        return this.$store.getters.activeTimer
      },
      set (data) {
        this.$store.dispatch('setActiveTimer', data)
      }
    },
    instanceStatus () {
      const { instanceStatus } = this.column
      return instanceStatus
    },
    isProjectTimer () {
      return REMINDER_STATUS.PROJECT === this.instanceStatus
    }
  },
  methods: {
    updateTotalTime () {
      const timeStart = moment(this.startDate, ['hh:mm A']).unix()
      const timeEnd = moment(this.endDate, ['hh:mm A']).unix()
      const diff = timeEnd - timeStart
      this.$emit('update:totalTime', diff * 1000)
    },
    updateManualTimer (newVal) {
      this.manualTimer = newVal
      const [hours, minutes, seconds] = newVal.split(':')
      const start = moment().set('hour', 0).set('minute', 0).set('seconds', 0)
      const end = moment().set('hour', hours).set('minute', minutes).set('seconds', seconds)
      this.startDate = new Date(start)
      this.endDate = new Date(end)
      this.updateTotalTime()
    },
    setManualTimer () {
      const timeStart = moment(this.startDate, ['hh:mm A']).unix()
      const timeEnd = moment(this.endDate, ['hh:mm A']).unix()
      if (timeStart > timeEnd) {
        this.manualTimer = '00:00:00'
        this.startDate = this.endDate
      } else {
        const diff = timeEnd - timeStart
        this.manualTimer = this.convertSecondsToTime(diff, true)
      }
    },
    createDateBackEnd (value) {
      const { startDate } = this.day
      const time = moment(value).format('HH:mm:ss')
      const date = moment(startDate).format('YYYY-MM-DD')
      const fullDate = `${date}T${time}`
      return this.convertToLocationDate(fullDate)
    },
    createBody () {
      const { subprojectId, project } = this.activeTimer
      const { _id } = this.row
      return {
        user: this.userInfo ? this.userInfo.id : '5f8097e4e06d0800124c7a5d',
        startDate: this.createDateBackEnd(this.startDate),
        endDate: this.createDateBackEnd(this.endDate),
        project: this.isProjectTimer ? subprojectId ? [project, subprojectId] : [project] : undefined,
        request: this.isProjectTimer ? undefined : [_id],
        instanceStatus: this.instanceStatus,
        ...this.body
      }
    },
    async createManualTimer () {
      const body = this.createBody()
      try {
        const { data } = await TimerApi.createManualTimer(body)
        this.isShowModal = false
        if (this.isProjectTimer) {
          this.updateProject({
            row: this.row,
            isSubproject: this.isSubproject,
            isHourProject: this.isHourProject,
            data
          })
        } else {
          const { totalTime: newTotalTime } = data
          const { totalTime } = this.row
          this.row.totalTime = totalTime + newTotalTime
          data.user = [{_id: data.user}]
          this.row.comments.unshift(data)
        }
      } catch (err) {
        console.error(err)
      }
    }
  },
  beforeMount () {
    if (this.totalTime) {
      this.manualTimer = this.convertSecondsToTime(this.totalTime / 1000, true)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../../sass/variables";

  .bbp-timer-modal-manual {
    display: flex;
    grid-gap: 0 20px;
  }

  .bbp-timer-modal-manual-picker {
    display: flex;
    align-items: center;
    grid-gap: 0 5px;

    &__dash {
      width: 7px;
      height: 1px;
      background: $color-black;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPTimer/BBPTimerModal/BBPTimerModalManual/BBPTimerModalManual.vue